import { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, Button } from "reactstrap";
import { createLane, updateLane } from "../../utils/driveThruApi";
import { successToast } from "../../shared/Toast";
import { C } from "../reporting/reportingStyles";

const headerStyle = { borderBottom: `2px solid ${C.borderLight}` };
const bodyStyle = { padding: 24, fontFamily: "'Inter', sans-serif" };
const footerStyle = { borderTop: `1px solid ${C.borderLight}`, gap: 8 };
const labelStyle = { fontSize: 12, fontWeight: 600, color: C.textMed, marginBottom: 6, display: "block" };
const inputStyle = { borderRadius: 8, border: `1.5px solid ${C.border}`, fontSize: 13, padding: "8px 12px", color: C.text };
const coralBtnStyle = { background: C.coral, border: "none", borderRadius: 10, fontWeight: 600, fontSize: 13 };
const ghostBtnStyle = { background: C.bg, border: `1px solid ${C.border}`, color: C.text, borderRadius: 10, fontWeight: 600, fontSize: 13 };

// Create/edit a drive-thru lane. `lane` null = create mode; branchId required for create.
const LaneModal = ({ isOpen, toggle, onSaved, lane, branchId }) => {
  const editing = !!lane;
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setName(lane?.name || "");
      setIsActive(lane?.isActive ?? true);
    }
  }, [isOpen, lane]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    const result = editing
      ? await updateLane(lane.id, { name: name.trim(), isActive })
      : await createLane({ branchId, name: name.trim(), isActive });
    setSaving(false);
    if (result) {
      successToast(editing ? "Lane updated" : "Lane created");
      onSaved();
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} style={headerStyle}>
        <span style={{ fontWeight: 700, color: C.text }}>{editing ? "Edit Lane" : "Add Lane"}</span>
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody style={bodyStyle}>
          <FormGroup>
            <label style={labelStyle}>Lane Name</label>
            <Input style={inputStyle} value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Lane 1" required />
          </FormGroup>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13, color: C.text, fontWeight: 600 }}>
            <Input type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} style={{ position: "static", margin: 0 }} />
            Active
          </label>
        </ModalBody>
        <ModalFooter style={footerStyle}>
          <Button type="button" onClick={toggle} style={ghostBtnStyle}>
            Cancel
          </Button>
          <Button type="submit" disabled={saving} style={coralBtnStyle}>
            {saving ? "Saving..." : "Save"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default LaneModal;
